import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useEffect, useRef, useState } from 'react';

const G_US: React.FC = () => {
    const { t } = useLang('dpux');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneGArr: any[] = [];
            const classArr = ['.label-ani', '.title-ani', '.desc-ani'];
            sceneGArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-G .info',
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        classArr.forEach((item) => {
                            document.querySelector(`.delta-pro-ultra-x-G .info ${item}`)?.classList.add('enter');
                        });
                    },
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            classArr.forEach((item) => {
                                document.querySelector(`.delta-pro-ultra-x-G .info ${item}`)?.classList.remove('enter');
                            });
                        }
                    },
                }),
            );
            return () => {
                sceneGArr.forEach((item) => item.destroy());
            };
        }
    }, []);

    // 新增动画
    const [enter, setEnter] = useState(false);
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!sectionRef.current) return;

        const screen = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '150%',
            duration: '100%',
            onEnter: () => {
                setEnter(true);
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    setEnter(false);
                }
            },
        });
        return () => {
            screen.destroy?.();
        };
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-G GtmModuleData-section`}
            id="delta-pro-ultra-x-G"
            data-section-id={'delta-pro-ultra-x-G'}
            data-section-title={t('G_title')}
            ref={sectionRef}
        >
            <div className={`sticky ${enter ? 'enter' : ''}`}>
                <div className="G-bg-img G-bg-img-1">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1760088008777/pc_High.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1760088008968/m_High.jpg"
                        isOpenLazy
                    />
                </div>
                <div className="G-bg-img G-bg-img-2">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1761122013029/PC_36kW%20(1).jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1761120993930/M_36kW.jpg"
                        isOpenLazy
                    />
                </div>
                <div className="info">
                    <div className="box">
                        <div className="label-ani ani-1">
                            <p className={`label `}>{t('G_label')}</p>
                        </div>
                        <div className="title-ani ani-2">
                            <p className={`title`}>{t('G_title')}</p>
                        </div>
                    </div>
                    <div className="desc-ani ani-3">
                        <div className={`desc `}>
                            {t.rich('G_desc', {
                                h: (v: string) => <span className="h">{v}</span>,
                            })}
                        </div>
                        <div className={`tips`}>
                            <div className="tips-title">
                                <div className="tips-num">
                                    <span className="tip1">
                                        {t('G_tips1')
                                            .split('')
                                            .map((i: string) => (
                                                <span key={i}>{i}</span>
                                            ))}
                                    </span>
                                    <span className="tip2">{t('G_tips2')}</span>
                                </div>
                                <div> {t('G_unit')}</div>
                            </div>
                            <div className="tips-desc">{enter ? t('G_tips2_desc') : t('G_tips1_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default G_US;
